module.exports = __webpack_public_path__ + "static/elixir.2e57b3d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/elixir.png
// module id = ./src/assets/icons/elixir.png
// module chunks = 0 1